import { createAction } from '../../utils/reduxUtils';
import { AsyncError, IAsyncError, INotificationPreferences } from '../../common';

export interface RequestFcmTokenPayload {
  permissionTranslationKey: string | false;
  silent: boolean;
}

const requestFcmToken = {
  request: createAction('@notification/REQUEST_FCM_TOKEN_REQUEST')<RequestFcmTokenPayload>,
  success: createAction('@notification/REQUEST_FCM_TOKEN_SUCCESS')<string>,
  failure: createAction('@notification/REQUEST_FCM_TOKEN_FAILURE')<IAsyncError>,
  cancel: createAction('@notification/REQUEST_FCM_TOKEN_CANCELED')<void>,
};

const deleteFcmToken = {
  request: createAction('@notification/DELETE_FCM_TOKEN_REQUEST')<void>,
  success: createAction('@notification/DELETE_FCM_TOKEN_SUCCESS')<void>,
  failure: createAction('@notification/DELETE_FCM_TOKEN_FAILURE')<IAsyncError>,
  cancel: createAction('@notification/DELETE_FCM_TOKEN_CANCELED')<void>,
};

const fetchNotificationPreferences = {
  request: createAction('@notification/FETCH_NOTIFICATION_PREFERENCES_REQUEST')<void>,
  success: createAction('@notification/FETCH_NOTIFICATION_PREFERENCES_SUCCESS')<INotificationPreferences>,
  failure: createAction('@notification/FETCH_NOTIFICATION_PREFERENCES_FAILURE')<IAsyncError>,
};

const updateNotificationPreferences = {
  prompt: createAction('@notification/UPDATE_NOTIFICATION_PREFERENCES_PROMPT')<void>,
  request: createAction('@notification/UPDATE_NOTIFICATION_PREFERENCES_REQUEST')<INotificationPreferences>,
  success: createAction('@notification/UPDATE_NOTIFICATION_PREFERENCES_SUCCESS')<INotificationPreferences>,
  failure: createAction('@notification/UPDATE_NOTIFICATION_PREFERENCES_FAILURE')<AsyncError>,
  canceled: createAction('@notification/UPDATE_NOTIFICATION_PREFERENCES_CANCELED')<void>,
};

const actions = {
  requestFcmToken,
  deleteFcmToken,
  fetchNotificationPreferences,
  updateNotificationPreferences,
};

export default actions;
